import { Stripe } from "@stripe/stripe-js";
import { ReactNode } from "react";
import { Elements } from "@stripe/react-stripe-js";

interface IStripeProviderProps {
    children: ReactNode;
    stripe: Stripe | null;
}

export default function StripeProvider({ children, stripe }: Readonly<IStripeProviderProps>) {
    if (stripe === null) {
        console.warn("Please initialize stripe before calling StripeProvider.");
        return null;
    }
    return <Elements stripe={stripe}>{children}</Elements>;
}
